exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js?minimize!../../../../assets/css/page-data.css"), "");

// module
exports.push([module.id, ".page-content-wrap[data-v-814cadde]{padding-left:0}.section-work[data-v-814cadde]{padding:0;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-814cadde","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/system/web_modules/slider/data.vue
// module id = 299
// module chunks = 0